import { Icon, IconProps } from '@chakra-ui/react'

export function WatcherLinkIcon(props: IconProps) {
  return (
    <Icon viewBox="0 0 16 16" fill="none" {...props}>
      <path
        d="M15.5 5.50001L15.5 0.500008M15.5 0.500008H10.5M15.5 0.500008L8 8M6.33333 0.5H4.5C3.09987 0.5 2.3998 0.5 1.86502 0.772484C1.39462 1.01217 1.01217 1.39462 0.772484 1.86502C0.5 2.3998 0.5 3.09987 0.5 4.5V11.5C0.5 12.9001 0.5 13.6002 0.772484 14.135C1.01217 14.6054 1.39462 14.9878 1.86502 15.2275C2.3998 15.5 3.09987 15.5 4.5 15.5H11.5C12.9001 15.5 13.6002 15.5 14.135 15.2275C14.6054 14.9878 14.9878 14.6054 15.2275 14.135C15.5 13.6002 15.5 12.9001 15.5 11.5V9.66667"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  )
}
